export default "__VITE_ASSET__BDkRj6ZU__"